<!-- 实体关联 -->
<template>
  <div class="entity-concat-view">
    <p class="info-title">关联服务商企业信息</p>

    <div class="info-content">
      <div class="info-item">
        <div class="label">所属企业编号：</div>

        <div class="value">{{ entityInfo.companyCode || '-' }}</div>
      </div>

      <div class="info-item">
        <div class="label">所属企业全称：</div>

        <div class="value">{{ entityInfo.companyFullName || '-' }}</div>
      </div>

      <div class="info-item">
        <div class="label">数据来源：</div>

        <a :href="entityInfo.dataResource" target="_blank">
          {{ entityInfo.dataResource || '-' }}
        </a>
      </div>
    </div>

    <p class="info-title">应用场景信息&nbsp;&nbsp;{{ getLength(entityInfo.scenarioList) }}</p>

    <div class="table-box ly_table_light">
      <el-table :data="entityInfo.scenarioList || []" border style="width: 700px"
      header-cell-class-name="ly_table_light_header">
        <el-table-column prop="scenarioId" label="应用场景编号" align="center"> </el-table-column>

        <el-table-column prop="sceneName" label="应用场景名称" align="center"> </el-table-column>
      </el-table>
    </div>

    <p class="info-title">案例信息&nbsp;&nbsp;{{ getLength(entityInfo.planList) }}</p>

    <div class="table-box ly_table_light">
      <el-table :data="entityInfo.planList || []" border style="width: 700px"
      header-cell-class-name="ly_table_light_header">
        <el-table-column prop="newId" label="案例实体编号" align="center"> </el-table-column>

        <el-table-column prop="planTitle" label="案例名称" align="center"> </el-table-column>

        <el-table-column prop="planIntro" label="案例简介" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// api
import { getEntityById } from "@/api/solvePlan.js"

export default {
  data() {
    //这里存放数据
    return {
      entityInfo:{}
    };
  },
  methods: {
    getInfo() {
      getEntityById({id: this.$route.query.companyCode}).then(res => {
        if(res.code === 200 && res.data) {
          this.entityInfo = res.data
        }
      })
    },
    getLength(arr) {
      if(Array.isArray(arr)) {
        return arr.length
      } else {
        return ''
      }
    }
  }
};
</script>

<style scoped lang="less">
.entity-concat-view {
  .info-title {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .info-content {
    padding-bottom: 20px;
    border-bottom: 20px solid #d8efff;
  }

  .info-item {
    display: flex;
    font-size: 16px;
    line-height: 40px;

    .label {
      width: 190px;
      text-align: right;
    }

    a {
      color: #000000;
    }
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;
  }
}
</style>
